export const version = 'berater-v1.16.0-SNAPSHOT-641f0f9ae3da341fb67ef514da2d70aaf31a0238';